import { FullStar, HalfStar } from 'components/Icons';
import times from 'lodash/times';
import { space } from 'mymoria-ui/custom/styledSystem';
import { SpaceProps } from 'mymoria-ui/interfaces';
import { mq, styled, css } from 'mymoria-ui/utils';
import React, { FunctionComponent, ReactNode } from 'react';
import { v4 } from 'uuid';

const StyledStar = styled.img();

const StyledInactiveStar = styled(StyledStar)({
  opacity: 0.3,
});

const Container = styled.div<SpaceProps>(
  () => css`
    display: flex;
    align-items: center;
    & > span {
      margin: 0 0.15rem;

      & > svg {
        ${mq({
          height: ['28px', '90%'],
          width: ['28px', '90%'],
        })};
      }
    }
  `,
  space,
);

interface Props extends SpaceProps {
  className?: string;
  count?: number;
  rate: number;
  personQuoting?: ReactNode;
}

const Rating: FunctionComponent<Props> = ({
  className,
  count = 5,
  rate = 3,
  personQuoting = null,
  ...props
}) => (
  <Container className={className} {...props}>
    {times(count, i => (
      <span key={v4()}>
        {i <= rate - 1 ? (
          <StyledStar src={FullStar} />
        ) : rate % 1 >= 0.5 && i < rate ? (
          <StyledStar src={HalfStar} />
        ) : (
          <StyledInactiveStar src={FullStar} />
        )}
      </span>
    ))}
    {personQuoting}
  </Container>
);

export default Rating;
